module.exports = __webpack_public_path__ + "static/media/maternity5.370fd45a.jpg";